import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import contact1 from '../../assets/contact1.png'
import address from '../../assets/address.webp'
import phone from '../../assets/phone.png'
import email from '../../assets/email.webp'
import './Contact.css'
import { Form, Input, Button, App, } from 'antd'
import loading from '../../assets/loading.gif'
import facebook from '../../assets/facebook.webp';
import instagram from '../../assets/insta.webp';
import linkedin from '../../assets/linkedin.webp';
import youtube from '../../assets/youtube.webp';
import { API } from '../../config/api'
import { POST } from '../../utils/apicalls'
import Header from '../componets/header/header'
import Footer from '../componets/footer/footer'
import { Helmet } from 'react-helmet';


function Contact() {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Hide loading after 5 seconds
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 900);

        // Cleanup the timer if component unmounts
        return () => clearTimeout(timer);
    }, []);

    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                ConactName: values.ConactName,
                ContactEmail: values.ContactEmail,
                ContactPhoneNumber: values.ContactPhoneNumber,
                ContactSubject: values.ContactSubject,
                ContactMessage: values.ContactMessage,
            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_CONTACT_FORM, obj);

            if (postRequest) {
                notification.success({ message: "Message sent successfully!" });
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <Helmet>
                <title>Contact Meantoir Global Academy– EA, CFE, CFS, CFM,IFRS Courses</title>
                <meta
                    name="description"
                    content="Contact us for admissions & counselling for EA, CFE, CFS, CFM & IFRS courses across India & Kerala, including Kochi, Trivandrum & Calicut." />

                <link rel="canonical" href="https://meantoir.com/contact" />
            </Helmet>
            {isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <img src={loading} alt="Contact EA course India" style={{ width: '400px', height: '400px' }} />
                </div>

            ) : (
                <div className="contact-page">
                    <Header />

                    <div className="contact-container">
                        {/* Left: Text & Info */}
                        <div className="contact-text">
                            <h1 className="contact-header">Contact Us</h1>
                            <h1>
                                Limitless Learning<br />With Meantoir
                            </h1>
                            <p>
                                We know that it is a privilege to walk your study journey beside you and we want to be there every step of the way.
                                If you need assistance, we are here to help.
                            </p>
                            <button onClick={() => navigate('/course')}>
                                Start Your Journey
                            </button>
                        </div>

                        {/* Right: Image */}
                        <div className="contact-image">
                            <img src={contact1} alt="Contact EA course India" />
                        </div>
                    </div>

                    <div className="contact-container-card">
                        {/* Phone Card */}
                        <div className="flip-card">
                            <div className="flip-card-inner">
                                <div className="flip-card-front">
                                    <img src={phone} alt="phone" className="Contact EA course India" />
                                    <strong>Call Us</strong>
                                </div>
                                <div className="flip-card-back">
                                    <a href="https://wa.me/919778127403" target="_blank" rel="noopener noreferrer" className="whatsapp-link">
                                        +91-9778127403
                                    </a><br />
                                    <a href="https://wa.me/919778127404" target="_blank" rel="noopener noreferrer" className="whatsapp-link">
                                        +91-9778127404
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Email Card */}
                        <div className="flip-card">
                            <div className="flip-card-inner">
                                <div className="flip-card-front">
                                    <img src={email} alt="Contact EA course India" className="contact-icon-card" />
                                    <strong>Email Us</strong>
                                </div>
                                <div className="flip-card-back">
                                    <a href="mailto:info@meantoir.com" className="email-link">
                                        info@meantoir.com
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Address Card */}
                        <div className="flip-card">
                            <div className="flip-card-inner">
                                <div className="flip-card-front">
                                    <img src={address} alt="Contact EA course Kerala" className="contact-icon-card" />
                                    <strong>Address</strong>
                                </div>
                                <div className="flip-card-back">
                                    Room 103, 1st Floor, Aiswarya Building, SA Road,<br /> Valanjambalam, Kochi, PIN: 682016
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="contact-wrapper">
                        <div className="contact-left">
                            <div className="contact-form-container">
                                <h1 className="contact-header">Contact Us</h1>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={submitHandler}
                                    initialValues={{
                                        ConactName: '',
                                        ContactPhoneNumber: '',
                                        ContactEmail: '',
                                        ContactSubject: '',
                                        ContactMessage: '',
                                    }}
                                >
                                    <Form.Item
                                        label="Name"
                                        name="ConactName"
                                        rules={[{ required: true, message: 'Please enter your name' }]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        label="Phone Number"
                                        name="ContactPhoneNumber"
                                        rules={[{ required: true, message: 'Please enter your phone number' }]}
                                    >
                                        <Input type="number" />
                                    </Form.Item>

                                    <Form.Item
                                        label="Email"
                                        name="ContactEmail"
                                        rules={[{ required: true, message: 'Please enter your email' }]}
                                    >
                                        <Input type="email" />
                                    </Form.Item>

                                    <Form.Item
                                        label="Subject"
                                        name="ContactSubject"
                                        rules={[{ required: true, message: 'Please enter the subject' }]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        label="Message"
                                        name="ContactMessage"
                                        rules={[{ required: true, message: 'Please enter your message' }]}
                                    >
                                        <Input.TextArea />
                                    </Form.Item>

                                    <Form.Item>
                                        <Button type="primary" htmlType="submit" loading={isLoading}>
                                            Send Message
                                        </Button>
                                    </Form.Item>
                                </Form>
                                {/* <h2 >Follow Us</h2> */}

                                <div className="footer-sections-social">
                                    <a href="https://www.linkedin.com/company/meantoir-global-academy/?viewAsMember=true" target="_blank" rel="noopener noreferrer">
                                        <img src={linkedin} className="social-icon" alt="Contact EA course Kerala" />
                                    </a>
                                    <a href="https://www.instagram.com/meantoir_global_academy/" target="_blank" rel="noopener noreferrer">
                                        <img src={instagram} className="social-icon" alt="Contact EA course Kerala" />
                                    </a>

                                    <a href="https://www.facebook.com/Meantoir-Global-Academy-61558424812934/" target="_blank" rel="noopener noreferrer">
                                        <img src={facebook} className="social-icon" alt="Contact EA course Kerala" style={{ width: "50px" }} />
                                    </a>
                                    <a href="https://youtube.com/@meantoirglobalacademy?si=Mx4uyCT9Wvicjsfv" target="_blank" rel="noopener noreferrer">
                                        <img src={youtube} className="social-icon" alt="Contact EA course Kerala" />
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div className="contact-right">
                            <iframe
                                title="Meantoir Global Academy™"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.066247673945!2d76.2868226!3d9.9645145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwNTcnNTIuMyJOIDc2wrAxNycyMS44IkU!5e0!3m2!1sen!2sin!4v1718600000000!5m2!1sen!2sin"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}

                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />

                        </div>
                    </div>

                    <Footer />
                </div>
            )}
        </div>
    )
}

export default Contact
